import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {map} from 'rxjs/operators';
import {ProductosPeriodosGraciasOtrosConceptos} from '../_models/productos-periodos-gracias-otros-conceptos';

@Injectable({
  providedIn: 'root'
})
export class ProductosPeriodosGraciasOtrosConceptosService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosPeriodosGraciasOtrosConceptos';

  constructor(private httClient: HttpClient, private autServicio: AutenticacionService) { }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ProductosPeriodosGraciasOtrosConceptos[] ) );
  }

  getByIdProductoPeriodoGracia( idProductoPeriodoGracia: string ) {
    return this.httClient.get( this.rutServicio + '/productosPeriodosGracias/' + idProductoPeriodoGracia ).pipe( map( res => res as ProductosPeriodosGraciasOtrosConceptos[] ) );
  }

  bulk( data: ProductosPeriodosGraciasOtrosConceptos [] ) {
    data.map( ( s: ProductosPeriodosGraciasOtrosConceptos ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk' , data ).pipe( map( res => res as any ) );
  }
  update( data: ProductosPeriodosGraciasOtrosConceptos ) {
    data.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, data ).pipe( map( res => res as ProductosPeriodosGraciasOtrosConceptos ) );
  }
}
